import React, { useEffect, useState } from "react";

function ContactPage() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "2rem",
        width: "100%",
        minHeight: "100vh",
        boxSizing: "border-box",
        padding: "2rem 0",
      }}
    >
      <div
        className="details-bar"
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: " #5A6872",
          width: "30vw",
          height: "70vh",
          fontFamily: "Anek Latin",
          padding: "2rem",
          fontSize: "1.5rem",
        }}
      >
        <h1 style={{ display: "flex", textAlign: "left", color: " #94C940" }}>
          Contact Us
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            fontWeight: "lighter",
            color: "rgb(254,255,255",
            textAlign: "left",
            letterSpacing: "normal",
            lineHeight: "28.6px",
          }}
        >
          Give us a call or fill out the form provided with a brief description
          of your project, and we'll schedule a consultation.​
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#FEFFFF",
            fontSize: "1.2rem",
            paddingTop: "1.5rem",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            width="24"
            viewBox="0 0 24 24"
            fill="#94C940"
            style={{ marginRight: "0.5rem" }}
          >
            <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z" />
          </svg>
          (313) 801-2500
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#FEFFFF",
            fontSize: "1.2rem",
            marginTop: "1rem",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            width="24"
            viewBox="0 0 24 24"
            fill="#94C940"
            style={{ marginRight: "0.5rem" }}
          >
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z" />
          </svg>
          360 E Maple Rd Suite M, Troy, MI 48083
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#FEFFFF",
            fontSize: "1.2rem",
            marginTop: "1rem",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            width="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#94C940"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ marginRight: "0.5rem" }}
          >
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <polyline points="3 7 12 13 21 7" />
          </svg>
          <a
            href="mailto:cs@seeourdesigns.com"
            style={{ color: "#FEFFFF", textDecoration: "none" }}
          >
            cs@seeourdesigns.com
          </a>
        </div>
      </div>
      <div>
        {/* <form
                action="mailto:cs@seeourdesigns.com"
                method="POST"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    background: "#fff",
                    padding: "2rem",
                    borderRadius: "8px",
                    width: "30vw",
                    fontFamily: "Anek Latin",
                    marginTop: "0",
                }}
            >
                <label style={{ color: "#5A6872", fontWeight: "bold" }}>
                    First Name
                    <input
                        type="text"
                        name="firstName"
                        required
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                            marginTop: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                        }}
                    />
                </label>
                <label style={{ color: "#5A6872", fontWeight: "bold" }}>
                    Last Name
                    <input
                        type="text"
                        name="lastName"
                        required
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                            marginTop: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                        }}
                    />
                </label>
                <label style={{ color: "#5A6872", fontWeight: "bold" }}>
                    Email
                    <input
                        type="email"
                        name="email"
                        required
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                            marginTop: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                        }}
                    />
                </label>
                <label style={{ color: "#5A6872", fontWeight: "bold" }}>
                    Message
                    <textarea
                        name="message"
                        required
                        rows={5}
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                            marginTop: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            resize: "vertical",
                        }}
                    />
                </label>
                <button
                    type="submit"
                    style={{
                        backgroundColor: "#94C940",
                        color: "#fff",
                        padding: "0.75rem",
                        border: "none",
                        borderRadius: "4px",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        cursor: "pointer",
                        marginTop: "1rem",
                    }}
                >
                    Send Message
                </button> 
            </form>*/}
      </div>
    </div>
  );
}

export default ContactPage;
